import React, { useEffect, useState } from 'react';
import { supabase } from '../../lib/supabaseClient';

const ProgressPage = () => {
  const [userId, setUserId] = useState(null);
  const [courses, setCourses] = useState([]);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    const fetchUser = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (user) setUserId(user.id);
    };
    fetchUser();
  }, []);

  useEffect(() => {
    const fetchProgress = async () => {
      if (!userId) return;
      const { data, error } = await supabase
        .from('user_courses')
        .select('*, courses(title)')
        .eq('user_id', userId);

      if (error) console.error('Error fetching progress:', error);
      else setCourses(data);
    };
    fetchProgress();
  }, [userId]);

  const filteredCourses = courses.filter(course => {
    if (filter === 'completed') return course.status === 'completed';
    if (filter === 'in_progress') return course.status === 'in_progress';
    return true; // all
  });

  const completedCount = courses.filter(c => c.status === 'completed').length;
  const inProgressCount = courses.filter(c => c.status === 'in_progress').length;
  const total = courses.length;
  const avgProgress =
    total > 0 ? Math.round(courses.reduce((sum, c) => sum + c.progress_percent, 0) / total) : 0;

  return (
    <div className="bg-white p-6 rounded-xl shadow">
      <h2 className="text-2xl font-semibold text-indigo-700 mb-4">Your Progress</h2>

      <div className="mb-4 flex gap-4 text-sm">
        <button onClick={() => setFilter('all')} className={`px-3 py-1 rounded ${filter === 'all' ? 'bg-indigo-600 text-white' : 'bg-gray-200'}`}>All</button>
        <button onClick={() => setFilter('in_progress')} className={`px-3 py-1 rounded ${filter === 'in_progress' ? 'bg-indigo-600 text-white' : 'bg-gray-200'}`}>In Progress</button>
        <button onClick={() => setFilter('completed')} className={`px-3 py-1 rounded ${filter === 'completed' ? 'bg-indigo-600 text-white' : 'bg-gray-200'}`}>Completed</button>
      </div>

      <ul className="space-y-4">
        {filteredCourses.map((course, index) => (
          <li key={index} className="flex justify-between items-center border p-4 rounded">
            <div>
              <p className="font-medium">{course.courses.title}</p>
              <p className="text-sm text-gray-600">{course.progress_percent}% — {course.status}</p>
            </div>
            <div className="w-32 bg-gray-200 rounded-full h-3 overflow-hidden">
              <div
                className="h-3 bg-indigo-600"
                style={{ width: `${course.progress_percent}%` }}
              ></div>
            </div>
          </li>
        ))}
      </ul>

      <div className="mt-6 text-sm text-gray-700">
        <p>Total Courses: {total}</p>
        <p>Completed: {completedCount}</p>
        <p>In Progress: {inProgressCount}</p>
        <p>Average Progress: {avgProgress}%</p>
      </div>
    </div>
  );
};

export default ProgressPage;